var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeteboardMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 32,
    fill: "none",
    viewBox: "0 0 38 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M7.094 4.246A6.825 6.825 0 0 1 .27 11.071a6.825 6.825 0 0 1 6.824 6.825 6.825 6.825 0 0 1 6.825-6.825 6.825 6.825 0 0 1-6.825-6.825Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m30.905 12.284-4.594 8.295a3.033 3.033 0 0 1-2.653 1.563H19.53c-.838 0-1.517.68-1.517 1.517v5.308A3.033 3.033 0 0 1 14.981 32H8.156V21.763a9.479 9.479 0 0 1 9.479-9.479h13.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M33.136 8.294a3.033 3.033 0 0 1-2.653 1.564H17.635C12.403 9.83 8.156 5.584 8.156.379V0H37.73l-4.594 8.294Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.044,
    x2: 5.063,
    y1: 9.04,
    y2: 13.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CA23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 31.057,
    x2: 8.156,
    y1: 4.853,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F054FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1709F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 31.057,
    x2: 8.156,
    y1: 4.853,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F054FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1709F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeteboardMobileIcon);
export default __webpack_public_path__ + "static/media/feteboard-mobile-icon.fd4f1eac2c581b2a332873eb3bfdc6cd.svg";
export { ForwardRef as ReactComponent };